import React from "react";

/**
 * FormSelect - Reusable select dropdown with consistent styling
 *
 * @param {Object} props
 * @param {string} props.id - Input ID
 * @param {string} props.label - Field label
 * @param {string} props.value - Selected value
 * @param {Function} props.onChange - Change handler
 * @param {Array} props.options - Array of options [{value, label}]
 * @param {boolean} props.required - Whether field is required
 * @param {string} props.className - Additional class names
 */
const FormSelect = ({
  id,
  label,
  value,
  onChange,
  options = [],
  required = false,
  className = "",
}) => {
  return (
    <div className={className}>
      <label
        htmlFor={id}
        className="block text-sm font-medium text-gray-300 mb-1"
      >
        {label} {required && <span className="text-red-400">*</span>}
      </label>
      <select
        id={id}
        value={value}
        onChange={onChange}
        className="w-full p-2 border border-[#2f3236] rounded focus:ring-[#4db1e0] focus:border-[#4db1e0] bg-[#262b30] text-gray-200"
        required={required}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FormSelect;
